module.exports = __webpack_public_path__ + "static/blueWithTagline-636963d2a138fdc673023eef1206ebfb.png";